import { useEffect, useState } from 'react';
import './App.css';
import { useNavigate } from "react-router-dom";
import img_tablet from './tablet.png';
import { ProgressSpinner } from 'primereact/progressspinner';
import axios from 'axios';
import { Button } from 'primereact/button';
import { Checkbox } from 'primereact/checkbox';

function ScreenLoginSuccess() {
    const navigate = useNavigate();
    const device_id = localStorage.getItem('device_id');
    const [device, setDevice] = useState(null);
    const [confirmRightToUse, setConfirmRightToUse] = useState(false);

    function getDevice() {
        axios.get(
            process.env.REACT_APP_API_HOST + `/devices/${device_id}/`,
            {}
        ).then(
            (response) => {
                setDevice(response.data);
            }
        )
    }

    useEffect(
        () => {
            if (!device_id) {
                navigate('/screen/login/');
                return;
            }
            getDevice();
        },
        [],
    )

    if (!device) {
        return (
            <div
                className='standard-box3'
                style={{ marginTop: '2em' }}
            >
                <ProgressSpinner />
            </div>
        );
    }

    return (
        <div>
            <div
                className='standard-box3'
                style={{ marginTop: '2em' }}
            >
                <h1>
                    Welcome!
                </h1>
            </div>
            <div
                className='standard-box3'
            >
                <h3>
                    You have successfully logged in with the following device:
                </h3>
                <div style={{ marginLeft: '2em' }}>
                    <div
                        style={{
                            marginTop: '2em',
                            display: 'flex',
                            flexWrap: 'wrap',
                            alignItems: 'center',
                        }}
                    >
                        <img src={img_tablet} width={200} />
                        <div style={{ marginLeft: '1em' }}>
                            <h3 style={{ marginLeft: '0.5em' }}>
                                {device.title}
                            </h3>
                        </div>
                    </div>
                    <div
                        style={{
                            marginTop: '2em',
                            display: 'flex',
                            cursor: 'pointer',
                        }}
                        onClick={
                            () => { setConfirmRightToUse(!confirmRightToUse) }
                        }
                    >
                        {/* <Checkbox
                            checked={confirmRightToUse}
                        />
                        <div style={{ marginLeft: '0.5em' }}>
                            I confirm that I am entitled to use this device.
                        </div> */}
                    </div>
                </div>
            </div>
            <div
                className='standard-box3'
            >
                <Button
                    severity='success'
                    label='Continue'
                    // disabled={!confirmRightToUse}
                    onClick={
                        () => {
                            navigate('/screen/')
                        }
                    }
                />
            </div>
        </div>
    );
}

export default ScreenLoginSuccess;